import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./components/pages/Auth/AuthContext";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { LINE_SEED_STACK } from "./components/GlobalFunction/Theme";

// ⬇️ add this import
import GlobalSnackbarProvider from "./components/GlobalFunction/GlobalSnackbarProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

const OFF_WHITE = "#fffffc";

const theme = createTheme({
  palette: {
    // Universal background colors
    background: {
      default: OFF_WHITE, // page background
      paper: OFF_WHITE,   // Paper background
    },
  },
  typography: {
    fontFamily: LINE_SEED_STACK,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          backgroundColor: OFF_WHITE,
        },
        body: {
          backgroundColor: OFF_WHITE,
          fontFamily: LINE_SEED_STACK,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        "#root": {
          backgroundColor: OFF_WHITE,
          minHeight: "100vh",
        },
      },
    },
    // Ensure all Papers default to the new off-white
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: OFF_WHITE,
        },
      },
    },
  },
});

root.render(
  <BrowserRouter>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Wrap the whole app so any component can call useGlobalSnackbar() */}
        <GlobalSnackbarProvider>
          <App />
        </GlobalSnackbarProvider>
      </ThemeProvider>
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
